export default {
  BACKSPACE: 8,
  ENTER: 13,
  ESCAPE: 27
};
